import React, { useEffect, useMemo, useState } from "react";
import AdminToggle from "../components/AdminToggle";
import ManageCategories from "../../../parts/categories/manage-categories";
import Header from "../../../parts/categories/header";
import ProductSelector from "../../../parts/categories/product-selector";
import submit from "submit-form";
import { useRillContext } from "../../../rill/RillReact/share/base";

const Tutorial = ({
  id,
  title = "Video Title Goes here",
  onClick = () => {},
  onRemove = () => {},
  thumbnail,
}) => {
  return (
    <div className="tutorial-item-container" onClick={() => onClick(id)}>
      <div
        className="tutorial-thumbnail"
        style={
          thumbnail
            ? {
                backgroundImage: `url(${thumbnail})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }
            : null
        }
      ></div>
      <div className="tutorial-info">
        <span className="tutorial-title">{title}</span>
        <div
          className="remove-button"
          onClick={(evt) => {
            evt.stopPropagation();
            onRemove(id);
          }}
        >
          <img alt="delete" src="/img/svg/trash.svg" className="icon-white" />
        </div>
      </div>
    </div>
  );
};

const TutorialCategory = ({ allCategories, allVideos, categoryNames }) => {
  const { locals } = useRillContext();

  const {
    query: { category, product },
  } = locals;

  const [isOpenSortable, setIsOpenSortable] = useState(false);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null);

  const categoryVideos = useMemo(() => {
    if (
      typeof selectedCategoryIndex !== "number" &&
      (!category || !selectedCategoryIndex || selectedCategoryIndex === "all")
    ) {
      return allVideos;
    }
    const resultCategoriesVideos = allVideos.filter(
      (video) => video.category === categoryNames[selectedCategoryIndex]
    );

    return resultCategoriesVideos;
  }, [allVideos, allCategories, selectedCategoryIndex]);

  useEffect(() => {
    if (category) {
      const categoryIndex = categoryNames.indexOf(category);
      setSelectedCategoryIndex(categoryIndex > -1 ? categoryIndex : null);
      return;
    }
    setSelectedCategoryIndex(null);
  }, [category]);

  // Handlers

  const getCategoryId = (_category) => {
    const findedCategory = allCategories.find(
      (category) => category.name === _category
    );
    return findedCategory ? findedCategory._id : null;
  };

  const addCategory = () => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "manage-categories",
        newCategory: true,
      },
    });
  };

  const selectCategory = (newSelectedCategory, category) => {
    setIsOpenSortable(false);
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        category,
      },
    });
  };

  const addTutorial = () => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "add-tutorial",
        selectedTutorial: "",
      },
    });
  };

  const selectTutorial = (tutorialId) => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "add-tutorial",
        selectedTutorial: tutorialId,
      },
    });
  };

  const removeTutorial = (tutorialId) => {
    submit("/actions/admin-panel/manage-category/video/delete", {
      method: "POST",
      body: {
        tutorialId,
      },
    });
  };

  const removeCategory = () => {
    let finalCategory = category;
    if (!finalCategory) {
      const findedCategory = allCategories[selectedCategoryIndex];
      if (!findedCategory) {
        setSelectedCategoryIndex(null);
      }
      finalCategory = findedCategory;
    }

    const bodyArgs = {
      category: finalCategory,
      product: product ? product : "general",
    };

    submit("/actions/admin-panel/manage-category/delete", {
      method: "POST",
      body: bodyArgs,
    });
  };

  const openCustomSort = () => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        "modal[type]": "sort-categories",
      },
    });
  };

  return (
    <main className="admin">
      <AdminToggle />

      <div className="Main Settings-Exercise-Library exercise-library-menu-container">
        <div
          className="top-bar"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              width: "80%",
            }}
          >
            <ProductSelector selected={product} isAdmin={true} />
          </div>
          <button data-button-type="primary" onClick={addTutorial}>
            <span>Add New Video</span>
          </button>
        </div>
        <Header
          generalCategories={categoryNames}
          showSortableMenu={isOpenSortable}
          showMostPopular={false}
          selectedCategory={category}
          selectedCategoryIndex={selectedCategoryIndex}
          toggleSortable={() => setIsOpenSortable(!isOpenSortable)}
          selectCategory={selectCategory}
          handleSort={() => {}}
          openCustomSort={openCustomSort}
          toggleMostPopular={() => {}}
          addCategory={addCategory}
          showUncategorized={false}
        />
        <div
          className="manage-bar-container"
          style={{
            margin: "14px 0px",
          }}
        >
          <ManageCategories
            category={category || "All"}
            selectedCategoryIndex={selectedCategoryIndex}
            selectedCategoryId={getCategoryId(category)}
            filteredItemsLength={categoryVideos.length}
            deleteCategory={() => removeCategory()}
            entity="Videos"
          />
        </div>
        <div className="tutorials-container">
          {categoryVideos.map((video, idx) => {
            return (
              <Tutorial
                key={idx}
                title={video.name}
                id={video._id}
                onClick={selectTutorial}
                onRemove={removeTutorial}
                thumbnail={video.thumbnail_url}
              />
            );
          })}
        </div>
      </div>
    </main>
  );
};

export default TutorialCategory;
